import React, { useEffect, useRef, useState } from "react";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import SelectFixo from "../../../components/SelectFixo";
import UploadFiles from "../../../components/UploadFiles";
import TrelloBoard from "../../../components/TrelloBoard";
import SubmitForm from "../../../components/SubmitForm";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { format } from "date-fns";

import PedidoItens from "../../../../lib/json/consultas/PedidoItens.json"
import NotaItens from "../../../../lib/json/consultas/NotaItens.json"
import AvaliacaoNF from "../../../../lib/json/consultas/AvaliacaoNotaFiscal.json"

import { ConsumoAPI_FileUpload } from "../../../../backend/ConsumoAPI";
import { ErroMsg, RetornaUsuarioLogado, SucessoMsg, calcularDiferencaEmDias, converteDataProtheus, formatDateColumnCard, formatarMoeda2, optionsStatusSC, parseLocaleNumber, arredondarParaCima } from "../../../contents/VariaveisGlobais";
import ConsultaTotvs from "../../../../backend/ConsultaTotvs";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { LabelInput } from "../../../components/InputGeral/styles";
import { HRDivider } from "../../CRM/Cadastros/FichaEtapa/styles";
import SelectFornecedor from "../../../components/Select/Fornecedor";
import SelectCondicaoPagamento from "../../../components/Select/CondicaoPagamento";
import SelectMoeda from "../../../components/Select/Moeda";
import { usePopUp } from "../../../components/BootBox";
import SelecaoPedidoCompra from "../../../components/SelecaoPedidoCompra";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import { handleValorTotalPCCard, handleValorUnitarioCard } from "../../../components/GridCell/Pedido";
import { handleUMedidaQtd, handlePedidoCompra } from "../../../components/GridCell/NotaFiscal";
import SelectEspecie from "../../../components/Select/Especie";
import AvaliacaoNotaFiscal from "../Fornecedores/AvaliacaoNotaFiscal";

function FichaNotaFiscal(){
    const navigate = useNavigate();
    const currentDate = new Date()
    const isFormVisual = window.location.href.includes('Visualizar');
    const refAvaliacao = useRef();
    
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus

    //idNotaFiscal = Documento + Serie + Fornecedor + Loja
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const { idNotaFiscal, empresaFilialCompras } = useParams();

    const [carregar, setCarregar] = useState(false);
    const [habilitaItem, setHabilitaItem] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);
    const [empresaFilial, setEmpresaFilial] = useState();
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState();
    
    //Campos Novos
    const [campoNumero, setCampoNumero] = useState('');
    const [campoSerie, setCampoSerie] = useState('001');
    const [campoFornecedor, setCampoFornecedor] = useState();
    const [campoDataEmissao, setCampoDataEmissao] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [campoDataDigitacao, setCampoDataDigitacao] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [campoCondicaoPagamento, setCampoCondicaoPagamento] = useState();
    const [campoEspecie, setCampoEspecie] = useState({value: '', label: 'Selecione a Espécie'});
    const [campoMoeda, setCampoMoeda] = useState({value: '', label: 'Selecione a Moeda'});
    const [campoAnexos, setCampoAnexos] = useState([]);
    const [campoDesconto,  setCampoDesconto] = useState(formatarMoeda2(0,4));
    const [campoValorDesconto, setCampoValorDesconto] = useState(0);
    const [campoValorFrete, setCampoValorFrete] = useState(formatarMoeda2(0,2));
    
    const [campoValorTotalProdutos,setCampoValorTotalProdutos] = useState(0);
    const [campoTotalICMS, setCampoTotalICMS] =useState(0);
    const [campoTotalIPI, setCampoTotalIPI] =useState(0);
    const [campoTotalPIS, setCampoTotalPIS] =useState(0);
    const [campoTotalCOFINS, setCampoTotalCOFINS] =useState(0);
    const [campoTotalISS, setCampoTotalISS] =useState(0);
    const [campoTotalIRRF, setCampoTotalIRRF] =useState(0);
    const [campoTotalINSS, setCampoTotalINSS] =useState(0);
    const [campoTotalCSLL, setCampoTotalCSLL] =useState(0);
    const [campoTotalDIFAL, setCampoTotalDIFAL] =useState(0);
    const [campoTotalICMSST, setCampoTotalICMSST] =useState(0);    
    const [campoTotalNota, setCampoTotalNota] = useState(0);
    
    const [dataItensNota, setDataItensNota] = useState([]);
    const [respostas, setRespostas] = useState({});
    
    const options = [
		{
			value: '1',
			text: "Normal",
		},
		{
			value: '2',
			text: "Regularização",
		},
		{
			value: '3',
			text: "Emergencial",
		},
		{
			value: '5',
			text: "Reposição",
		},
        {
            value: '6',
            text: "Compra Direta",
        }
	];

    var dataPedidoCompra = []

    const loadNotaFiscal = async() => {
        
        if ( idNotaFiscal ) {
            let consultaDefault = NotaItens.consulta;
        
            consultaDefault += "AND F1_FILIAL = FILIAL(SF1) ";
            consultaDefault += "AND F1_DOC + F1_SERIE + F1_FORNECE + F1_LOJA = '" + idNotaFiscal + "'";

            setCarregar(true);
            var retConsulta = await ConsultaTotvs( consultaDefault, NotaItens.tabelas, empresaFilialCompras );

            if (retConsulta.data){
                let aItens = []
                retConsulta.data.map( (item, index) => {
                    const Produto = {value: item.D1_COD, label: item.D1_COD + ' - ' + item.DESCRI}
                    const Armazem = {value: item.D1_LOCAL, label: item.D1_LOCAL + ' - ' + item.NNR_DESCRI}
                    const ContaContabil = {value: item.D1_CONTA, label: item.D1_CONTA + ' - ' + item.CT1_DESC01}
                    const CentroCusto = {value: item.D1_CC, label: item.D1_CC + ' - ' + item.CTT_DESC01}
                    const CentroCustoReposicao = {value: item.D1_CCR, label: item.D1_CCR + ' - ' + item.CTT_DESCR}
                    
                    const dataEmissao = converteDataProtheus(item.F1_EMISSAO);
                    const dataEntrega = converteDataProtheus(item.F1_DTDIGIT);
                    const cAnexoNF = (item.F1_XANEXO.trim() || '[]').replaceAll('ORIGINALNAME', 'originalname').replaceAll('FILENAME', 'filename'); //Campo Tabela Sistema
                    
                    const Fornecedor = {value: item.D1_FORNECE + '' + item.D1_LOJA, label: item.D1_FORNECE + '/' + item.D1_LOJA + ' - ' + item.A2_NOME.trim() + '(' + item.A2_CGC.trim() + ')'}
                    const CondicaoPagamento = {value: item.F1_COND, label: ''}
                    const Moeda = {value: item.F1_MOEDA.toString(), label: ''}
                    const Especie = {value: item.F1_ESPECIE.trim(), label: ''}

                    if ( index === 0 ){
                        setEmpresaFilialSelect(empresaFilialCompras) 
                        setCampoFornecedor(Fornecedor)
                        setCampoDataEmissao(dataEmissao);
                        setCampoDataDigitacao(dataEntrega);
                        setCampoNumero(item.D1_DOC);
                        setCampoSerie(item.D1_SERIE);                        
                        setCampoEspecie(Especie);               
                        setCampoMoeda(Moeda);
                        setCampoCondicaoPagamento(CondicaoPagamento);
                        setCampoValorFrete(formatarMoeda2(parseFloat(item.F1_FRETE),2))
                        // setCampoDesconto(formatarMoeda2(parseFloat(item.D1_DESC),4))
                        setCampoAnexos(JSON.parse(cAnexoNF))
                    }

                    aItens.push({ 
                        item: item.D1_ITEM,
                        produto: Produto,
                        unidadeMedida: item.D1_UM,
                        descricaoComplementar: item.D1_OBS,
                        campoArmazem: Armazem,
                        campoContaContabil: ContaContabil,
                        campoCentroCusto: CentroCusto,
                        campoCentroCustoReposicao: CentroCustoReposicao,
                        saldo: formatarMoeda2(parseFloat((item.QUANT || '0')),4),
                        quantidade: formatarMoeda2(parseFloat(item.D1_QUANT),4),
                        valorUnitario: formatarMoeda2(parseFloat(item.D1_VUNIT),4),
                        valorTotal: formatarMoeda2(parseFloat(item.D1_TOTAL),2),
                        icms: { IMPOSTO: 'ICMS', BASE: formatarMoeda2(parseFloat(item.D1_BASEICM),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_PICM),2), VALOR: formatarMoeda2(parseFloat(item.D1_VALICM),2) },
                        ipi: { IMPOSTO: 'IPI', BASE: formatarMoeda2(parseFloat(item.D1_BASEIPI),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_IPI),2), VALOR: formatarMoeda2(parseFloat(item.D1_VALIPI),2) },
                        pis: { IMPOSTO: 'PIS', BASE: formatarMoeda2(parseFloat(item.D1_BASIMP6),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_XALIMP6),2), VALOR: formatarMoeda2(parseFloat(item.D1_VALIMP6),2) },
                        cofins: { IMPOSTO: 'COFINS', BASE: formatarMoeda2(parseFloat(item.D1_BASIMP5),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_XALIMP5),2), VALOR: formatarMoeda2(parseFloat(item.D1_VALIMP5),2) },
                        iss: { IMPOSTO: 'ISS', BASE: formatarMoeda2(parseFloat(item.D1_BASEISS),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_ALIQISS),2), VALOR: formatarMoeda2(parseFloat(item.D1_VALISS),2) },
                        irrf: { IMPOSTO: 'IRRF', BASE: formatarMoeda2(parseFloat(item.D1_BASEIR),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_ALIQIR),2), VALOR: formatarMoeda2(parseFloat(item.D1_VALIR),2) },
                        inss: { IMPOSTO: 'INSS', BASE: formatarMoeda2(parseFloat(item.D1_BASEINS),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_ALIQINS),2), VALOR: formatarMoeda2(parseFloat(item.D1_VALINS),2) },
                        csll: { IMPOSTO: 'CSLL', BASE: formatarMoeda2(parseFloat(item.D1_BASECSL),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_ALQCSL),2), VALOR: formatarMoeda2(parseFloat(item.D1_VALCSL),2) },
                        difal: { IMPOSTO: 'DIFAL', BASE: formatarMoeda2(parseFloat(item.D1_BASEDES),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_ALIQCMP),2), VALOR: formatarMoeda2(parseFloat(item.D1_ICMCOMP),2) },
                        icmsST: { IMPOSTO: 'ICMSST', BASE: formatarMoeda2(parseFloat(item.D1_BASESOL),2), ALIQUOTA: formatarMoeda2(parseFloat(item.D1_ALIQSOL),2), VALOR: formatarMoeda2(parseFloat(item.D1_ICMSRET),2) },
                        // percentualDesconto: 0,
                        desconto: parseFloat(item.D1_VALDESC,2),
                        pedido: item.D1_PEDIDO,
                        itemPedido: item.D1_ITEMPC,
                        deletado: false,
                        E4_COND: item.E4_COND,
                        C7_COND: item.F1_COND,
                        E4_DESCRI: item.E4_DESCRI,
                        finalidade: item.DHK_DESCR
                    })
                });

                setDataItensNota(aItens);
            }

            setCarregar(false);
        }
    }

    useEffect( () => {
        const fetchData = async() => {
            await loadNotaFiscal()

            if (!(usuarioProtheus && usuarioProtheus.value.trim())) {
                ErroMsg("Usuário Protheus não vincludado ou Usuário não tem Permissão de Acesso!");
                navigate('/compras/NotaFiscal');
            }
        }

        fetchData()
    }, []);

    const columnsItensPedido = [
        {
            Header: 'Pedido Compra',
            accessor: 'pedido',
            render: handlePedidoCompra
        },
        {
            Header: 'Produto',
            accessor: 'produto.label',
        },
        {
            Header: 'U. M.',
            accessor: 'unidadeMedida',
            render: handleUMedidaQtd
        },
        {
            Header: 'Qtde.',
            accessor: 'quantidade',
            render: handleValorUnitarioCard
        },
        {
            Header: 'Valor Total',
            accessor: 'valorTotal',
            render: handleValorTotalPCCard
        },
        {
            Header: 'Centro de Custo',
            accessor: 'campoCentroCusto.label',
        },
    ]

    const columnsAditional = [
        {
            Header: 'Conta Contabil',
            accessor: 'campoContaContabil.label',
        },
        {
            Header: 'Descrição Complementar',
            accessor: 'descricaoComplementar'
        }
    ]

    const handleAddFilesNF = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];

        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexos, ...newFiles]
            setCampoAnexos(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFilesNF = (fileDelete) => {
        const updatedFiles = [...campoAnexos];
        updatedFiles.splice(fileDelete, 1);

        setCampoAnexos(updatedFiles)
        return updatedFiles;
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    function formatarImposto(obj) {
        obj.BASE = formatarMoeda2(parseFloat(obj.BASE),2);
        obj.ALIQUOTA = formatarMoeda2(parseFloat(obj.ALIQUOTA),2);
        obj.VALOR = formatarMoeda2(parseFloat(obj.VALOR),2);

        return obj;
    }

    const calculaTotais = () => {
        if (dataItensNota && dataItensNota.length > 0){
            let nTotalICMS      = 0;
            let nTotalIPI       = 0;
            let nTotalPIS       = 0;
            let nTotalISS       = 0;
            let nTotalIRRF      = 0;
            let nTotalINSS      = 0;
            let nTotalCSLL      = 0;
            let nTotalDIFAL     = 0;
            let nTotalICMSST    = 0;
            let nValorDesconto  = 0;
            let nValorTotal     = 0;
            let nTotalPedido    = 0;

            dataItensNota.forEach((item) => {
                if (item.deletado === false){
                    const nProduto = parseLocaleNumber(item.valorTotal)
                    const totalItem = parseLocaleNumber(item.valorTotal) - item.desconto + 
                    ( ( parseLocaleNumber(item.ipi?.VALOR) || 0 ) + ( parseLocaleNumber(item.pis?.VALOR) || 0 ) +
                     ( parseLocaleNumber(item.iss?.VALOR) || 0 ) + ( parseLocaleNumber(item.irrf?.VALOR) || 0 ) + ( parseLocaleNumber(item.inss?.VALOR) || 0 ) +
                     ( parseLocaleNumber(item.csll?.VALOR) || 0 ) + ( parseLocaleNumber(item.difal?.VALOR) || 0 )  )

                    nTotalICMS      += parseLocaleNumber(item.icms?.VALOR) || 0
                    nTotalIPI       += parseLocaleNumber(item.ipi?.VALOR) || 0
                    nTotalPIS       += parseLocaleNumber(item.pis?.VALOR) || 0
                    nTotalISS       += parseLocaleNumber(item.iss?.VALOR) || 0
                    nTotalIRRF      += parseLocaleNumber(item.irrf?.VALOR) || 0
                    nTotalINSS      += parseLocaleNumber(item.inss?.VALOR) || 0
                    nTotalCSLL      += parseLocaleNumber(item.csll?.VALOR) || 0
                    nTotalDIFAL     += parseLocaleNumber(item.difal?.VALOR) || 0
                    nTotalICMSST    += parseLocaleNumber(item.icmsST?.VALOR) || 0
                    nValorDesconto  += item.desconto
                    nValorTotal     += nProduto
                    nTotalPedido    += totalItem
                }
            })

            setCampoTotalICMS(nTotalICMS.toFixed(2));
            setCampoTotalIPI(nTotalIPI.toFixed(2));
            setCampoTotalPIS(nTotalPIS.toFixed(2));
            setCampoTotalISS(nTotalISS.toFixed(2));
            setCampoTotalIRRF(nTotalIRRF.toFixed(2));
            setCampoTotalINSS(nTotalINSS.toFixed(2));
            setCampoTotalCSLL(nTotalCSLL.toFixed(2));
            setCampoTotalDIFAL(nTotalDIFAL.toFixed(2));
            setCampoTotalICMSST(nTotalICMSST.toFixed(2));
            setCampoValorDesconto(nValorDesconto.toFixed(2));
            setCampoValorTotalProdutos(nValorTotal.toFixed(2));

            nTotalPedido += parseLocaleNumber(campoValorFrete);

            setCampoTotalNota(nTotalPedido.toFixed(2));
        }
    }

    const handleVincularItem = async() => {
        setCarregar(true);

        let cEmpresaFilial = empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL)
        let consulta = "SELECT C7_NUM, C7_EMISSAO, SUM(C7_TOTAL) C7_TOTAL, SUM( CASE WHEN ((C7_TOTAL - C7_VLDESC)  / C7_QUANT * ( C7_QUANT - C7_QUJE - C7_QUJB - C7_QTDACLA ) > 0) THEN  (C7_TOTAL - C7_VLDESC) / C7_QUANT * ( C7_QUANT - C7_QUJE - C7_QUJB - C7_QTDACLA ) ELSE 0 END) SALDO " + 
            "FROM TABELA(SC7) SC7 " +
            "WHERE SC7.D_E_L_E_T_ <> '*' " +
            " AND C7_FILIAL = FILIAL(SC7) " +
            " AND C7_FORNECE = '" + campoFornecedor.value.substr(0,6) + "' "+
            " AND C7_LOJA = '" + campoFornecedor.value.substr(6,4) + "' " + 
            " AND C7_QUANT > (C7_QUJE + C7_QTDACLA + C7_QUJB) " +
            " AND C7_CONAPRO NOT IN ('B','R') " +
            " AND C7_RESIDUO <> 'S' "

		// " AND C7_EMISSAO > '20250101' " +
        
        //Ignorar SC que já está vinculada
        const pcVinculado = dataItensNota.map( (item) => {return item.pedido + item.itemPedido}).join("','")

        if (pcVinculado){
            consulta += " AND C7_NUM + C7_ITEM NOT IN ('" + pcVinculado + "') "
        }
        
        consulta += " GROUP BY C7_NUM, C7_EMISSAO "
        consulta += " ORDER BY C7_NUM, C7_EMISSAO "
        
        const retConsulta = await ConsultaTotvsEmpresa(consulta, "SC7;CTT", cEmpresaFilial)
        
        if (retConsulta.data){
            if (retConsulta.data.length > 0){
                dataPedidoCompra = retConsulta.data.map( (item) => { item.Check = false; return item });
            }
        }

        setCarregar(false);
        if (dataPedidoCompra.length > 0){
            SelecaoPedidoCompra( DisparaBootBox, FechaSelecaoPC, dataPedidoCompra);
        }
    }

    const FechaSelecaoPC = async() => {
        FechaBootBox()

        const pcSelecionado = dataPedidoCompra.filter( (item) => item.Check === true)
        const numerosPC = pcSelecionado.map( (item) => {return item.C7_NUM}).join("','")

        dataPedidoCompra = []
        if (numerosPC){
            setCarregar(true);

            let cEmpresaFilial = empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL)
            let consulta = PedidoItens.consulta + 
                " AND C7_FILIAL = FILIAL(SC7) " +
                " AND C7_FORNECE = '" + campoFornecedor.value.substr(0,6) + "' "+
                " AND C7_LOJA = '" + campoFornecedor.value.substr(6,4) + "' " + 
                " AND C7_QUANT > (C7_QUJE + C7_QTDACLA + C7_QUJB) " +
                " AND C7_RESIDUO <> 'S' "

		    // " AND C7_EMISSAO > '20250101' " +

            consulta += " AND C7_NUM IN ('" + numerosPC + "') "
            
            //Ignorar SC que já está vinculada
            const pcVinculado = dataItensNota.map( (item) => {return item.pedido + item.itemPedido}).join("','")

            if (pcVinculado){
                consulta += " AND C7_NUM + C7_ITEM NOT IN ('" + pcVinculado + "') "
            }
            
            consulta += " ORDER BY C7_NUM, C7_ITEM "
            
            const retConsulta = await ConsultaTotvsEmpresa(consulta, PedidoItens.tabelas, cEmpresaFilial)
            
            if (retConsulta.data){
                if (retConsulta.data.length > 0){
                    dataPedidoCompra = retConsulta.data.map( (item) => { item.Check = false; return item });
                }
            }

            setCarregar(false);
        
            SelecaoPedidoCompra( DisparaBootBox, FechaSelecaoItensPC, dataPedidoCompra, "I");
        }
    }

    const FechaSelecaoItensPC = async() => {
        FechaBootBox()
        setCarregar(true);
        let pcSelecionado = dataPedidoCompra.filter( (item) => item.Check === true)
        
        if (pcSelecionado && pcSelecionado.length > 0){
            const dataLastItem = dataItensNota.findLast( (item) => item.item )
            let lastItem = parseFloat( dataLastItem ? dataLastItem.item : '0')
            
            let newItens = await retornaItemFormatado(pcSelecionado, lastItem);

            const newDataPC = [...dataItensNota, ...newItens];

            //Pegar a Melhor Condição de Pagamento - Maior Prazo Inicial e Maior Parcelamento
            const melhorCondicaoPagamento = encontrarMelhorCondicao(newDataPC)
            const CondicaoPagamento = {value: melhorCondicaoPagamento.C7_COND, label: melhorCondicaoPagamento.E4_DESCRI}

            setCampoCondicaoPagamento(CondicaoPagamento);
            setDataItensNota(newDataPC)
        }        
        setCarregar(false)
    }

    const encontrarMelhorCondicao = (condicoes) => {
        return condicoes.map((item) => {
            const prazos = item.E4_COND.trim().split(',').map(Number);
            return {
                ...item,
                prazoInicial: prazos[0],
                totalParcelas: prazos.length,
            };
        }).sort((a, b) => {
            if (b.prazoInicial !== a.prazoInicial) {
                return b.prazoInicial - a.prazoInicial;
            }
            return b.totalParcelas - a.totalParcelas;
        })[0];
    };

    const retornaItemFormatado = async(pcSelecionado, lastItem) => {
        return await Promise.all(pcSelecionado.map( async(itemMap) => { 
            lastItem++
            const proximoItem = String(lastItem)
            const saldo = parseFloat(itemMap.C7_QUANT) - parseFloat(itemMap.C7_QUJE) - parseFloat(itemMap.C7_QTDACLA) - parseFloat(itemMap.C7_QUJB)
            const preco = parseFloat(itemMap.C7_PRECO)
            const qtdSelecionada = parseFloat(parseLocaleNumber(itemMap.QTDSEL)) // Retornar o campo do Input que vamos criar
            const descontoItem = parseFloat(parseLocaleNumber(itemMap.DESCSEL)) // Retornar o campo do Input que vamos criar
            const total = parseFloat(parseLocaleNumber(itemMap.TOTAL))
            
            const jsonEnvio = {
                FORNECEDOR: itemMap.C7_FORNECE,
                LOJA: itemMap.C7_LOJA,
                PRODUTO: itemMap.C7_PRODUTO,
                QUANTIDADE: itemMap.QTDSEL,
                PRECO: itemMap.C7_PRECO,
                TOTAL: total,
                FINALIDADE: itemMap.C7_TIPCOM
            }
            
            const retornoCalculaImposto = await ConsumoTOTVS_POST('CALCULAIMPOSTO', jsonEnvio, empresaFilial)
            const retImposto = retornoCalculaImposto?.data || [];

            const icms = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ICMS')[0]);
            const ipi = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'IPI')[0]);
            const pis = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'PIS')[0]);
            const cofins = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'COFINS')[0]);
            const iss = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ISS')[0]);
            const irrf = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'IRRF')[0]);
            const inss = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'INSS')[0]);
            const csll = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'CSLL')[0]);
            const difal = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'DIFAL')[0]);
            const icmsST = formatarImposto(retImposto.filter( (itemImposto) => itemImposto.IMPOSTO === 'ICMSST')[0]);

            const item = {
                item: proximoItem.padStart(4, '0'),
                produto: {value: itemMap.C7_PRODUTO, label: itemMap.C7_PRODUTO + ' - ' + itemMap.DESCRI},
                unidadeMedida: itemMap.C7_UM,
                descricaoComplementar: itemMap.C7_OBS,
                campoArmazem: {value: itemMap.C7_LOCAL, label: itemMap.C7_LOCAL + ' - ' + itemMap.NNR_DESCRI},
                campoContaContabil: {value: itemMap.C7_CONTA, label: itemMap.C7_CONTA + ' - ' + itemMap.CT1_DESC01},
                campoCentroCusto: {value: itemMap.C7_CC, label: itemMap.C7_CC + ' - ' + itemMap.CTT_DESC01},
                campoCentroCustoReposicao: {value: itemMap.C7_CCR, label: itemMap.C7_CCR + ' - ' + itemMap.CC_REP},
                saldo: formatarMoeda2(parseFloat(saldo),4),
                quantidade: formatarMoeda2(parseFloat(qtdSelecionada),4),
                valorUnitario: formatarMoeda2(parseFloat(itemMap.C7_PRECO),4),
                valorTotal: formatarMoeda2(total,2),
                icms,
                ipi,
                pis,
                cofins,
                iss,
                irrf,
                inss,
                csll,
                difal,
                icmsST,
                // percentualDesconto: 0,
                desconto: descontoItem,
                pedido: itemMap.C7_NUM,
                itemPedido: itemMap.C7_ITEM,
                deletado: false,
                E4_COND: itemMap.E4_COND,
                C7_COND: itemMap.C7_COND,
                E4_DESCRI: itemMap.E4_DESCRI,
                finalidade: itemMap.DHK_DESCR
            }

            return item
        }));
    }

    useEffect( ()=> {
        calculaTotais();
    }, [dataItensNota, campoValorFrete])

    const handleExcluirItem = (itemParaExcluir) => {
        const id = itemParaExcluir.item;

        setDataItensNota((prevData) => {
            // 1. Remove o item com o ID informado
            const novoArray = prevData.filter((item) => item.item !== id);

            // 2. Reorganiza o campo 'item' como "0001", "0002", ...
            return novoArray.map((item, index) => ({
                ...item,
                item: (index + 1).toString().padStart(4, '0'),
            }));
        });
    };

    const handleSalvar = async() =>{
        if (!campoNumero) {
            toast.warning('O prenchimento do campo de Documento é obrigatório.');
            return false;
        }
        if (!usuarioProtheus) {
            toast.warning('Usuário do sistema Protheus, não Identificdo.');
            return false;
        }
        if (!campoDataEmissao) {
            toast.warning('O prenchimento do campo de Data de Emissão é obrigatório.');
            return false;
        }
        if (!campoFornecedor) {
            toast.warning('O prenchimento do campo de Fornecedor é obrigatório.');
            return false;
        }
        if (!campoAnexos || campoAnexos.length === 0) {
            toast.warning('O prenchimento do campo de Anexo é obrigatório.');
            return false;
        }
        if (campoNumero.trim().length < 9 ) {
            toast.warning('O Campo Número da Nota Fiscal está inferior ao tamanho de 9 caracteres.');
            return false;
        }
        
        // return saveNota()
        let cConsulta = AvaliacaoNF.consulta
        cConsulta += " AND A2_COD + A2_LOJA = '" + campoFornecedor.value + "' "

        const oPergunta = await ConsultaTotvs( cConsulta, AvaliacaoNF.tabelas )
        
        if (oPergunta.data){
            const perguntasMock = oPergunta.data.map( (item) => { 
                const aPergunta = item.ZT9_DESCRI.split('||')

                return {
                    CodigoPergunta: item.PTY_IDAVAL,
                    DescricaoPergunta: aPergunta[0],
                    Valor: "",
                    PesoPergunta: aPergunta[1],
                    Opcoes: item.OPCOES,
                    Desabilitar: false
                }
            })

            // Renderiza o componente diretamente no BootBox
            DisparaBootBox(
                `Avaliação Fornecedor - ${campoFornecedor.label}`,
                () => <AvaliacaoNotaFiscal ref={refAvaliacao} perguntas={perguntasMock}  />,
                [
                    { variant: 'success', action: () => saveNota(refAvaliacao), label: '✓ Salvar' },
                    { variant: 'light', action: FechaBootBox, label: '↩ Voltar' }
                ],
                null,
                false,
                'xl',
                true,
                true // withComponent = true
            );
			
			return false
        }else{
            return saveNota()
        }
    }
    
    const saveNota = async(ref) => {
        const respostas = ref?.current?.getRespostas() || [];
        const nota = ref?.current?.getNota() || '0';
        FechaBootBox()
        setCarregar(true)
        
        const grupoAprova = window._env_?.REACT_APP_APROVA_NF || "";
        let cJSONSalvar;
        let oRetorno
        const dataItensSalvar = dataItensNota.map((item) => { 
            const nTotalProduto = parseLocaleNumber(item.valorTotal)
            // const descontoItem = parseLocaleNumber(campoDesconto) > 0 ? parseFloat((nTotalProduto * (parseLocaleNumber(campoDesconto)/100)).toFixed(2),2) : 0;
            // const totalItem = parseFloat(nTotalProduto - descontoItem.toFixed(2),2)
            const totalItem = parseFloat(nTotalProduto,2)

            item.fornecedor = campoFornecedor;
            item.emissao = campoDataEmissao;
            item.digitacao = campoDataDigitacao;
            item.numero = campoNumero;
            item.serie = campoSerie;
            item.especie = campoEspecie;
            item.moeda = campoMoeda
            item.condicaoPagamento = campoCondicaoPagamento
            item.tipoFrete = { value: '', text: '', label: '' };
            item.frete = parseLocaleNumber(campoValorFrete);
            // item.percentualDesconto = parseLocaleNumber(campoDesconto);
            // item.desconto = descontoItem;
            item.anexo = JSON.stringify(campoAnexos).replaceAll('originalname', 'ORIGINALNAME').replaceAll('filename', 'FILENAME');
            item.grupoAprovacao = grupoAprova;
            item.totalItem = totalItem;
            item.usuario = usuarioProtheus;
            item.avaliacao = JSON.stringify(respostas);
            item.nota = nota;

            return item
        })
                
        cJSONSalvar = JSON.stringify(dataItensSalvar)
        
        if ( idNotaFiscal ) {
            oRetorno = await ConsumoTOTVS_POST('ALTERARNOTAFISCAL', cJSONSalvar, empresaFilial)
        }else{
            oRetorno = await ConsumoTOTVS_POST('NOVANOTAFISCAL', cJSONSalvar, empresaFilial)
        }
        
        setCarregar(false)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)

            const caminho = retCaminho()            
            navigate(caminho, { relative: "path" });
        }else{
            ErroMsg(oRetorno.description)
            return false;
        }
    }

    const retCaminho = () => {
        let caminho = window.location.pathname
        let index
        
        if (window.location.pathname.includes('Visualizar') ){
            index = caminho.indexOf('/Visualizar');
        }
        if (window.location.pathname.includes('Alterar') ){
            index = caminho.indexOf('/Alterar');
        }
        if (window.location.pathname.includes('Incluir') ){
            index = caminho.indexOf('/Incluir');
        }
        if (window.location.pathname.includes('Copiar') ){
            index = caminho.indexOf('/Copiar');
        }

        return caminho.substring(0, index);
    }

    const handleCampoNumero = async() => {
        const value = campoNumero.trim().padStart(9, '0');

        const consulta = "SELECT COUNT(*) QTD FROM TABELA(SF1) " +
            " WHERE F1_FORNECE = '" + campoFornecedor.value.substr(0,6) + "' "+
            " AND F1_LOJA = '" + campoFornecedor.value.substr(6,4) + "' " + 
            " AND F1_EMISSAO = '" + campoDataEmissao.replaceAll('-','') + "' " +
            " AND F1_DOC = '" + value + "' " +
            " AND F1_FILIAL = '" + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) + "' " +
            " AND D_E_L_E_T_ != '*' "

        const retConsulta = await ConsultaTotvsEmpresa(consulta, "SF1")
        if (retConsulta){
            if (retConsulta.data[0].QTD > 0){
                toast.error("Foi identificado Documento Fiscal de Numero NF " + value + " para esse fornecedor já lançado no sistema!");
                setCampoNumero("");
                return
            }
        }
        
        setCampoNumero(value);
    }
    
    const handleCampoSerie = () => {
        let value = campoSerie.trim().padStart(3, '0');
        
        setCampoSerie(value);
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text={`Nota Fiscal de Compras`}
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial && (
                <>
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Dados da NF: </h5>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="8" xs="12">
                            <SelectFornecedor
                                campoFornecedor={campoFornecedor}
                                changeFornecedor={setCampoFornecedor}
                                empresaLogada={empresaFilial}
                                returnOriginal={true}
                                disabled={disabledForm}
                            />
                        </Col>                    
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Data de Emissão"
                                placeholder="Data de Emissão"
                                tipo="date"
                                value={campoDataEmissao}
                                onChange={(e) => setCampoDataEmissao(e.target.value)}
                                max={format(currentDate, 'yyyy-MM-dd')}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Data Digitação"
                                placeholder="Data Digitação"
                                tipo="date"
                                value={campoDataDigitacao}
                                onChange={(e) => setCampoDataDigitacao(e.target.value)}
                                disabled={true}
                            />
                        </Col>
                        { campoFornecedor && campoFornecedor?.value && (
                            <>
                                <Col md="3" xs="12">
                                    <InputGeral
                                        label="Documento"
                                        placeholder="Documento"
                                        tipo="text"
                                        value={campoNumero}
                                        handleBlur={handleCampoNumero}
                                        onChange={(e) => setCampoNumero(e.target.value)}
                                        disabled={disabledForm}
                                        max={9}
                                    />
                                </Col>
                                <Col md="3" xs="12">
                                    <InputGeral
                                        label="Série"
                                        placeholder="Série"
                                        tipo="text"
                                        value={campoSerie}
                                        onChange={(e) => setCampoSerie(e.target.value)}
                                        handleBlur={handleCampoSerie}
                                        disabled={disabledForm}
                                        max={3}
                                    />
                                </Col>
                                <Col md="3" xs="12">
                                    <SelectEspecie                            
                                        campoEspecie={campoEspecie}
                                        changeEspecie={setCampoEspecie}
                                        empresaLogada={empresaFilial}
                                        disabled={disabledForm}
                                    />
                                </Col>
                                <Col md="3" xs="12">
                                    <SelectMoeda
                                        campoMoeda={campoMoeda}
                                        changeMoeda={setCampoMoeda}
                                        empresaLogada={empresaFilial}
                                        disabled={disabledForm}
                                    />
                                </Col>
                                <Col md="6" xs="12">
                                    <SelectCondicaoPagamento
                                        campoCondPagto={campoCondicaoPagamento}
                                        changeCondPagto={setCampoCondicaoPagamento}
                                        empresaLogada={empresaFilial}
                                        disabled={true}
                                    />
                                </Col>
                            </>
                        )}
                    </Row>

                    <HRDivider/>
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Itens da Nota Fiscal: </h5>
                        </Col>
                        { !habilitaItem && campoFornecedor?.value && campoNumero && !disabledForm && (                        
                            <>
                                <Col md="2" xs="12" >
                                    <Button variant="primary" className="w-100" onClick={handleVincularItem}>
                                        { '🔗 Vincular Itens' }
                                    </Button>
                                </Col>
                            </>
                        )}
                    </Row>
                </>
            )}
            { dataItensNota && dataItensNota.length > 0 &&
                <TrelloBoard 
                    columns={columnsItensPedido} 
                    data={dataItensNota.filter((item) => item.deletado === false)} 
                    titleLista="Item: "
                    columnsAditional={columnsAditional}
                    buttons= { disabledForm ? [] : 
                            [   
                                // {action: handleAlterarItem, label: "Alterar", icone: "MdOutlineEditNote", style: "outline-info"},
                                {action: handleExcluirItem, label: "Excluir", icone: "MdPlaylistRemove", style: "outline-danger" }
                            ]
                    }
                    mdColCard={3}
                    mdColCardOpen={12}
                    tamanhoCard="75lvh"
                />
            }
            { empresaFilial && (
                <>
                    <Row>
                        {/* <Col md="3" xs="12">
                            <InputGeral
                                label="% Desconto 1"
                                placeholder="Percentual 1º Desconto"
                                tipo="monetario"
                                value={campoDesconto}
                                onChange={(e, value) => setCampoDesconto(value)}
                                decimal={4}
                                disabled={disabledForm}
                            />
                        </Col> */}
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Total Desconto"
                                placeholder="Desconto"
                                tipo="monetario"
                                value={campoValorDesconto}
                                onChange={(e) => setCampoValorDesconto(e)}
                                disabled={true}
                                decimal={4}
                            />
                        </Col>
						<Col md="3" xs="12">
							<InputGeral
								label="Valor do Frete"
								placeholder="Valor do Frete"
								tipo="monetario"
								value={campoValorFrete}
								onChange={(e,value) => setCampoValorFrete(value)}
								decimal={2}
							/>
						</Col>
                        <Col md="3" xs="12"></Col>
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Total Produtos"
                                placeholder="Total Produtos"
                                tipo="monetario"
                                value={campoValorTotalProdutos}
                                disabled={true}
                                onChange={(e) => setCampoValorTotalProdutos(e)}
                                decimal={2}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="9" xs="12"></Col>
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Total Nota Fiscal"
                                placeholder="Total Nota Fiscal"
                                tipo="monetario"
                                value={campoTotalNota}
                                disabled={true}
                                onChange={(e) => setCampoTotalNota(e)}
                                decimal={2}
                            />
                        </Col>
                    </Row>
                    <Row>
                        { (campoTotalICMS > 0 || campoTotalIPI > 0 || campoTotalPIS > 0 || campoTotalCOFINS > 0 || campoTotalISS > 0 || campoTotalIRRF > 0 || campoTotalINSS > 0 || campoTotalCSLL > 0 || campoTotalDIFAL > 0 || campoTotalICMSST > 0) && (
                            <Col md="12" xs="12">
                                <h5>Total de Impostos Nota Fiscal: </h5>
                            </Col>
                        )}
                        { campoTotalICMS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total ICMS"
                                    placeholder="Total de ICMS"
                                    tipo="monetario"
                                    value={campoTotalICMS}
                                    onChange={(e) => setCampoTotalICMS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalIPI > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total IPI"
                                    placeholder="Total de IPI"
                                    tipo="monetario"
                                    value={campoTotalIPI}
                                    onChange={(e) => setCampoTotalIPI(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalPIS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total PIS"
                                    placeholder="Total de PIS"
                                    tipo="monetario"
                                    value={campoTotalPIS}
                                    onChange={(e) => setCampoTotalPIS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalCOFINS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total COFINS"
                                    placeholder="Total de COFINS"
                                    tipo="monetario"
                                    value={campoTotalCOFINS}
                                    onChange={(e) => setCampoTotalCOFINS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalISS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total ISS"
                                    placeholder="Total de ISS"
                                    tipo="monetario"
                                    value={campoTotalISS}
                                    onChange={(e) => setCampoTotalISS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalIRRF > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total IRRF"
                                    placeholder="Total de IRRF"
                                    tipo="monetario"
                                    value={campoTotalIRRF}
                                    onChange={(e) => setCampoTotalIRRF(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalINSS > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total INSS"
                                    placeholder="Total de INSS"
                                    tipo="monetario"
                                    value={campoTotalINSS}
                                    onChange={(e) => setCampoTotalINSS(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalCSLL > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total CSLL"
                                    placeholder="Total de CSLL"
                                    tipo="monetario"
                                    value={campoTotalCSLL}
                                    onChange={(e) => setCampoTotalCSLL(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalDIFAL > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total DIFAL"
                                    placeholder="Total de DIFAL"
                                    tipo="monetario"
                                    value={campoTotalDIFAL}
                                    onChange={(e) => setCampoTotalDIFAL(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                        { campoTotalICMSST > 0 && (
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Total ICMS-ST"
                                    placeholder="Total de ICMS-ST"
                                    tipo="monetario"
                                    value={campoTotalICMSST}
                                    onChange={(e) => setCampoTotalICMSST(e)}
                                    disabled={true}
                                    decimal={4}
                                />
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <LabelInput>Anexos da Nota Fiscal</LabelInput>
                            <UploadFiles 
                                onDropEvent={handleAddFilesNF}
                                onDeleteEvent={handleDelFilesNF}
                                value={campoAnexos}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                </>
            )}
            { dataItensNota && dataItensNota.length > 0 && 
                <SubmitForm 
                    onSave={ disabledForm ? null : handleSalvar}
                    onCancel={ disabledForm ? null : 'handleVoltar'}
                    onVoltar={ disabledForm ? 'handleVoltar' : null}
                />
            }
        </>
    );
}

export default FichaNotaFiscal;